module.exports = __webpack_public_path__ + "img/B高通锐化200.a5ad029a.png";